/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'cBjmdjW8dXRt5PWwdEuVQd.png': { uri: '/images/cBjmdjW8dXRt5PWwdEuVQd.png' },
's2DhhGWXPi9n5rcjkdhGkp.png': { uri: '/images/s2DhhGWXPi9n5rcjkdhGkp.png' },
'7ZqfAkGmmKqcUa5ZPNE31C.webp': { uri: '/images/7ZqfAkGmmKqcUa5ZPNE31C.webp' },
'47MRzDKDexjNbDJpDJhUzW.png': { uri: '/images/47MRzDKDexjNbDJpDJhUzW.png' }
}

export default imageStaticSourcesByFileName
